import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})

export class CustomLayoutRoutes {

  constructor(private router: Router) {

  }

  navigateToMainPage() {

    this.router.navigate(["dashboard"]);
  }

  navigateToRegister() {
    this.router.navigate(["register"]);
  }
  navigateToUpdatePassword() {
    this.router.navigate(["update-password"]);
  }
}